import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "remote-choices--ratio-select" }
const _hoisted_2 = {
  value: "",
  disabled: "",
  selected: ""
}
const _hoisted_3 = ["value", "selected"]

import {ref, computed} from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RatioSelect',
  props: {
        ratio: Number,
        dataTestid: String,
        error: Boolean,
        limit: Number,
        required: Boolean,
    },
  emits: ["update:ratio"],
  setup(__props, { emit: __emit }) {

    const props = __props;
    const emit = __emit;
    const error = ref<boolean>(false);

    function handleSelectChange(event: CustomEvent) {
        error.value = !event.detail.value;
        emit('update:ratio', Number(event.detail.value));
    }

    const frequencyWithLimit = computed((): number => {
        if (!props.limit) {
            return 4;
        }
        if (props.limit <= 1) {
            return 1;
        }
        return props.limit - 1;
    });

return (_ctx: any,_cache: any) => {
  const _component_joy_select = _resolveComponent("joy-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_select, {
      required: __props.required || null,
      "required-mark": __props.required || null,
      label: _ctx.$msg('client.project.component.remote.choices.ratio.label'),
      name: "remote-choices-frequency",
      invalid: error.value,
      "invalid-message": error.value ? _ctx.$msg('form.field.error.message.required.generic') : null,
      "data-testid": __props.dataTestid,
      value: __props.ratio,
      onJoySelectChange: handleSelectChange
    }, {
      default: _withCtx(() => [
        _createElementVNode("option", _hoisted_2, _toDisplayString(_ctx.$msg('client.project.component.remote.choices.status.placeholder')), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(frequencyWithLimit.value, (count) => {
          return (_openBlock(), _createElementBlock("option", {
            key: `remote-ratio-option-${count}`,
            value: count,
            selected: count === __props.ratio
          }, _toDisplayString(_ctx.$icu('client.project.component.remote.choices.ratio.option', {count})), 9, _hoisted_3))
        }), 128))
      ]),
      _: 1
    }, 8, ["required", "required-mark", "label", "invalid", "invalid-message", "data-testid", "value"])
  ]))
}
}

})